/** Resolve an `ipfs://CID/path` URI through a gateway. Pass-through for http(s). */
export function ipfsToHttp(uri: string, gateway: string): string {
  if (uri.startsWith("ipfs://")) return gateway + uri.slice("ipfs://".length);
  return uri;
}
